import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { history } from './history';
import { createRootReducer } from '../reducers';
import { isNotProduction } from '../helpers/environment';

const isProduction = !isNotProduction();

export const store = configureStore({
    reducer: createRootReducer(history),
    devTools: !isProduction,
    middleware: getDefaultMiddleware => ([...getDefaultMiddleware({
        serializableCheck: false,
    }), routerMiddleware(history)]),
});

// типизация стора
export type RootState = ReturnType<typeof store.getState>;

// хачим диспатч чтобы можно было вызывать экшены не только через хуки
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

// типизация селектора
export const useTypeSelector:TypedUseSelectorHook<RootState> = useSelector;
